import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getMappingStatus = api((registerId) =>
    !registerId
        ? {}
        : query(
              gql`
                  query GetMappingStatus($registerId: String!) {
                      getMappingStatus(registerId: $registerId)
                  }
              `,
              { registerId },
              { returns: "getMappingStatus" }
          )
)
